import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import {
  Box,
  Checkbox,
  FormControlLabel,
  MenuItem,
  styled,
  Typography,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import ButtonBlue from "../../shared/general/ButtonBlue";
import DrawerCustom from "../../shared/general/Drawer";
import TextFieldTheme from "../../shared/general/TextFieldTheme";

const Content = styled("div")({
  width: "500px",
  maxWidth: "500px",
  "& .content-padding": {
    padding: "16px",
  },
  "& .sub-topic": {
    fontWeight: "500",
  },
  "& .value": {
    fontSize: "20px",
    fontWeight: "500",
  },
  "& .flex-between": {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "16px",
  },
  "& .flex-end": {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "16px",
  },
});

const DrawerSetting = ({ open, onClose, data }) => {
  const { t } = useTranslation();
  const [year, setYear] = useState(dayjs().date(1).month(0).format("YYYY-MM-DD"));
  const [holidayPattern, setHolidayPattern] = useState(null);

  useEffect(() => {
    setYear(dayjs().date(1).month(0).format("YYYY-MM-DD"));
  }, [open]);

  useEffect(() => {
    console.log("data : ",data);
    console.log("year : ",year);
    if(data && year){
      let textYear = dayjs(year).format("YYYY");
      let resultHolidayPattern = null;

      if(data.holidayPattern && data.holidayPattern[textYear] && data.holidayPattern[textYear].listHolidayPattern.length > 0){
        let hp = data.holidayPattern[textYear];
        for(let i = 0; i < hp.listHolidayPattern.length; i++){
          if(hp.listHolidayPattern[i].idHolidayPattern === hp.idHolidayPattern){
            resultHolidayPattern = hp.listHolidayPattern[i];
          }
        }
      }

      setHolidayPattern(resultHolidayPattern);
    }else{
      setHolidayPattern(null);
    }
  },[data, year]);

  return (
    <DrawerCustom
      title={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography>{t("Setting")}</Typography>
          <Typography>
            {`ชื่อกะ :`}
            <span
              style={{ fontSize: "20px", fontWeight: "500", marginLeft: "8px" }}
            >
              {(data && data.nameShiftGroup) || "-"}
            </span>
          </Typography>
        </div>
      }
      anchor="right"
      open={open}
      onClose={onClose}
    >
      <Content>
        {data ? (
          <div className="content-padding">
            <Typography fontWeight="600" fontSize="14px" color="#919eab">
              {t("HolidayPattern")}
            </Typography>
            <div className="flex-between">
              <Typography className="sub-topic">
                {t("AnnualHoliday")}
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={year}
                  onChange={(newValue) => {
                    setYear(newValue);
                  }}
                  views={["year"]}
                  inputFormat="YYYY"
                  minDate={
                    data && data.shiftStartDate
                      ? dayjs(data.shiftStartDate).date(1).month(0)
                      : dayjs().date(1).month(0)
                  }
                  maxDate={dayjs().date(1).month(0)}
                  renderInput={(params) => {
                    return (
                      <TextFieldTheme
                        {...params}
                        style={{
                          width: "fit-content",
                          minWidth: "200px",
                          maxWidth: "200px",
                        }}
                      />
                    );
                  }}
                />
              </LocalizationProvider>
            </div>
            <div className="flex-between">
              <Typography className="sub-topic">
                {`${t("HolidayPattern")} : `}
              </Typography>
            </div>
            <div className="flex-between">
              <Typography className="value">
                {holidayPattern ? holidayPattern.name : "-"}
              </Typography>
            </div>
            <div className="flex-end">
              <ButtonBlue onClick={onClose}>{t("Close")}</ButtonBlue>
            </div>
          </div>
        ) : (
          <Fragment></Fragment>
        )}
      </Content>
    </DrawerCustom>
  );
};

export default DrawerSetting;
